// src/screens/components/Footer.jsx
import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-gray-100 text-gray-600 py-4 border-t mt-auto">
      <div className="max-w-7xl mx-auto px-4 text-center text-sm">
        © {new Date().getFullYear()} Sistema de Riego. Todos los derechos reservados.
      </div>
    </footer>
  );
}
